/*
  Alverane ürün kartı: şerit kaydırıldıkça nokta göstergesini günceller ve
  ilk görselden ayrılınca masaüstü hover crossfade'ini kapatır. Vanilla JS.
*/

if (!customElements.get('alv-product-card')) {
  class AlvProductCard extends HTMLElement {
    connectedCallback() {
      this.strip = this.querySelector('[data-alv-strip]');
      this.dots = Array.from(this.querySelectorAll('[data-alv-dots] .alv-card__dot'));
      if (!this.strip || this.dots.length < 2) return;
      this.strip.addEventListener('scroll', () => this.schedule(), { passive: true });
    }

    schedule() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const width = this.strip.clientWidth || 1;
      const index = Math.round(this.strip.scrollLeft / width);
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      this.classList.toggle('is-scrolled', index !== 0);
    }
  }

  customElements.define('alv-product-card', AlvProductCard);
}
